export enum UserRoleEnum {
  Contractor = 0,
  FacilityAdmin = 1,
  ShiftAdministrator = 2,
  BusinessAdministrator = 3,
  CorporateStaff = 4,
  SuperAdmin = 5
}
